// Repositions the Gorgias chat button above the sticky add-to-cart bar.
const stickyBar = document.querySelector('product-add-to-cart-sticky');

if (stickyBar) {
  const TRANSITION = 'bottom 0.25s cubic-bezier(0.104, 0.204, 0.492, 1)';
  const CHAT_Z = '2147483648';
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const config = {
    mobile:  { right: '8px',  cssBottom: 15, gap: 8 },
    desktop: { right: '22px', cssBottom: 30, gap: 12 },
  };

  function reposition() {
    const chat = document.getElementById('chat-button');
    if (!chat) return;

    const isMobile = mobileQuery.matches;
    const isVisible = stickyBar.classList.contains('sticky--visible');
    const { right, cssBottom, gap } = isMobile ? config.mobile : config.desktop;

    const bottomValue = isVisible
      ? `${cssBottom + stickyBar.offsetHeight + gap}px`
      : '';

    Object.assign(chat.style, {
      right: isVisible ? right : '',
      bottom: bottomValue,
      transition: TRANSITION,
      zIndex: CHAT_Z,
    });
  }

  new MutationObserver(reposition).observe(stickyBar, { attributeFilter: ['class'] });
  new ResizeObserver(reposition).observe(stickyBar);
  mobileQuery.addEventListener('change', reposition);
  reposition();
}
